// extracted by css-extract-rspack-plugin
export default {"button":"button-OkhD3g"};